<template>
  <div>
    <!-- iterate product categories -->
    <v-row
      v-for="(
        productCategory, productCategoryIndex
      ) in productsInstance.getAllProductCategories(
        excludeEventTemplates,
        excludeRequests,
        excludeRequired
      )"
      :key="productCategoryIndex"
    >
      <v-col class="col-12 pb-0">
        <v-row>
          <!-- product category title -->
          <v-col class="col-12 headline-standard pl-6 primary--text pb-0">
            <span class="border-bottom">
              {{
                productCategory.getProductCategoryTitle() ||
                $t('products.archive')
              }}
            </span>
          </v-col>

          <!-- iterate products -->
          <v-col
            v-for="(
              product, productIndex
            ) in productsInstance.getProductsByProductCategory(
              productCategory.productCategory
            )"
            :key="productIndex"
            class="col-3 pt-2"
          >
            <v-card
              outlined
              :class="{ 'grey lighten-2': !product.isActive() }"
              @click="$emit('click:product', product)"
            >
              <v-card-title style="height: 90px" class="py-0">
                <v-row class="fill-height align-center">
                  <v-col
                    style="word-break: break-word"
                    class="py-0"
                    :class="[
                      displayMode === 'cashDesk'
                        ? 'col-12 content-3'
                        : 'col-10 content-4',
                    ]"
                  >
                    <span
                      v-if="!product.isActive()"
                      class="fal fa-eye-slash mr-1"
                    />
                    <span v-if="$store.getters.getExtTransLoaded()">
                      {{ product.getTitle() }}
                    </span>
                    <span v-else class="fal fa-circle-notch fa-spin" />
                  </v-col>

                  <!-- edit pen -->
                  <v-col v-if="displayMode !== 'cashDesk'" class="col-2">
                    <v-btn
                      icon
                      color="primary"
                      class="white"
                      :class="{ 'grey lighten-2': !product.isActive() }"
                    >
                      <span class="fal fa-pen" />
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Products from '../../classes-shared/products/Products'

export default {
  name: 'Products',

  props: {
    // show event template products or not
    excludeEventTemplates: {
      required: false,
      type: Boolean,
      default: false,
    },

    // show products which are for user request (only submit form)
    excludeRequests: {
      required: false,
      type: Boolean,
      default: false,
    },

    excludeRequired: {
      required: false,
      type: Boolean,
      default: false,
    },

    // modes: cashDesk | default
    displayMode: {
      required: false,
      type: String,
      default: 'default',
    },

    excludeInactive: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      productsInstance: new Products(),
    }
  },

  async mounted() {
    await this.productsInstance.loadProducts(null, true, !this.excludeInactive)
  },
}
</script>
